import IconLaneTop from './IconLaneTop';

export default IconLaneTop;